<template>
  <div id="top-bar" :class="{ bottom: isFrontPage && login}">
    <div v-if="login != undefined" class="top">
      <div :class="{ border: isScroll }" class="user" v-if="user && user.gravatar">
        <div class="img" :style="$bgd(user.gravatar)" @click="$emit('user')" />
        <p v-if="isFrontPage" class="text down" ref="welcomeText">{{ welcomeText }}</p>
        <p v-if="!isFrontPage" class="text up">{{ welcomeText }}</p>
      </div>
      <div v-if="!login" :class="{ border: isScroll }" class="user login">
        <p class="left">AnyTeach 约课平台</p>
        <router-link to="/login" tag="p" class="right login-button">
          登录
          <i class="anyteachicon anyteach-icon-test" />
        </router-link>
      </div>
      <div v-if="isFrontPage && !login" class="welcome">
        <h1>{{ welcomeText }}</h1>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "TopBar",
  props: {
    welcome: Boolean,
    isFrontPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth || document.documentElement.clientWidth || 400,
      isScroll: false,
    }
  },
  computed: {
    newUserReward: function () {
      return this.$store.state.newUserReward ? ` ${this.$store.state.newUserReward} 元` : ""
    },
    welcomeText: function () {
      const now = this.$moment()
      let first = "您好"
      if (this.user && this.user.name) {
        first = this.user.name
      } else if (now.hour() < 12) {
        first = "早上好"
      } else if (now.hour() < 13) {
        first = "中午好"
      } else if (now.hour() < 18) {
        first = "下午好"
      } else {
        first = "晚上好"
      }
      return `${first}，学点什么？`
    },
    user() {
      return this.$store.state.user
    },
    login() {
      return this.$store.state.login
    },
  },
  activated() {
    this.bindScroll()
  },
  deactivated() {
    window.onscroll = null
  },
  watch: {
    isScroll: function (val) {
      if (!this.$refs.welcomeText) return
      this.setClass()
    },
    login: function (val) {
      this.$nextTick(() => { this.setClass() })
    }
  },
  methods: {
    setClass() {
      if (!this.$refs.welcomeText) return
      if (this.isScroll) {
        this.$refs.welcomeText.classList.remove("down")
        this.$refs.welcomeText.classList.add("up")
      } else {
        this.$refs.welcomeText.classList.remove("up")
        this.$refs.welcomeText.classList.add("down")
      }
    },
    checkScroll() {
      this.isScroll = window.scrollY > 10
    },
    bindScroll() {
      this.checkScroll()
      window.onscroll = () => {
        this.checkScroll()
      }
    },
  },
}
</script>
<style scoped lang="scss">
.bottom {
  padding-bottom: 95px;
}
#top-bar {
  $deep-shadow: 0 0 50px -5px #a9a9a9;
  .border {
    border-color: #eee !important;
  }
  .top {
    .login {
      display: flex;
      justify-content: space-between;
      .login-button {
        color: $red;
        i {
          margin-left: 3px;
          font-size: 0.9rem;
        }
      }
      p {
        font-size: 0.9rem;
        @include avenir-demi();
        height: 35px;
        line-height: 35px;
      }
    }
    .welcome {
      padding: 55px 5% 5px 5%;
      h1 {
        font-size: 1.5625rem;
        @include avenir-demi();
        color: $black;
      }
    }
    .user {
      background: white;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      padding: 8px 5%;
      z-index: 99;
      display: flex;
      align-items: center;
      transition: all 0.3s ease;
      border-bottom: 1px solid white;
      .img {
        $size: 35px;
        width: $size;
        height: $size;
        border-radius: 100%;
        margin-right: 8px;
      }
      .text {
        @include avenir-demi();
        display: inline;
        color: $black;
        position: absolute;
        font-size: 0.8rem;
        transition: all 0.25s;
        top: 50%;
        transform-origin: left center;
        i {
          font-size: 12px;
        }
      }

      // .up {
      //   left: calc(5% + 43px);
      //   top: 50%;
      //   transform: translateZ(0) translateY(-50%);
      //   font-size: 0.8rem;
      // }
      // .down {
      //   font-size: 1.5625rem;
      //   transform: translateZ(0);
      //   left: 5%;
      //   top: 60px;
      // }

      .up {
        transform: translate(43px, -50%);
      }
      .down {
        transform: translate(0, 35px) scale(2);
      }
    }
  }
}
</style>
